class Breakdown {
    constructor(breakdown, breakdownFilter) {
        this.breakdown = breakdown || "region";
        this.breakdownFilter = breakdownFilter || "";
    }
}
const BreakdownList = [
    { key: "region", text: "Region" },
    { key: "license", text: "License" },
    { key: "location", text: "Location" },
    { key: "fullName", text: "Partner" },
    { key: "assignmentId", text: "Assignment" },
    { key: "company", text: "Company" },
    { key: "parent", text: "Parent" },
    { key: "function", text: "Function" },
    { key: "industry", text: "Industry" },
    { key: "reportGroup", text: "Report Group" },
    { key: "practiceGroup", text: "Practice Group" },
    { key: "subsector", text: "Subsector" } // requires breakdown of ["reportGroups"] json
];
export { Breakdown, BreakdownList };
